var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":"rgba(153, 0, 0, 1)","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleNavigationBar}}),_c('v-toolbar-title',[_vm._v("Conserved Unique Peptide Patterns (CUPP)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }